import React, { useCallback, useEffect, useState } from "react";
import { graphqlRequest } from "../../../utils/graphqlRequest";

export default function ClientReportSharing({ projectId }) {
  const [data, setData] = useState(null),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try {
      const d = await graphqlRequest(
        `query($id:String!){adminClientProjectSharing(projectId:$id)}`,
        { id: projectId },
      );
      setData(d.adminClientProjectSharing);
      setError("");
    } catch (e) {
      setError(e.message);
    }
  }, [projectId]);
  useEffect(() => {
    load();
  }, [load]);
  async function save(enabled, visitId) {
    setBusy(true);
    try {
      await graphqlRequest(
        `mutation($id:String!,$enabled:Boolean,$visitId:String){setClientReportVisibility(projectId:$id,enabled:$enabled,visitId:$visitId)}`,
        { id: projectId, enabled, visitId: visitId || null },
      );
      await load();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="pd-section">
      <h3>Client service report sharing</h3>
      <p>
        Only approved reports are shared. Enable the project default, then
        override individual visits when needed. Internal notes, payroll and
        staff contacts remain private.
      </p>
      {error && (
        <p role="alert" style={{ color: "#b91c1c" }}>
          {error}
        </p>
      )}
      {data ? (
        <>
          <label>
            <input
              disabled={busy}
              type="checkbox"
              checked={data.enabled}
              onChange={(e) => save(e.target.checked)}
            />{" "}
            Share approved reports for this project
          </label>
          <table style={{ width: "100%", marginTop: 20 }}>
            <thead>
              <tr>
                <th>Visit date</th>
                <th>Rostered start</th>
                <th>Report visibility</th>
              </tr>
            </thead>
            <tbody>
              {data.visits.map((v) => (
                <tr key={v.id}>
                  <td>{v.date}</td>
                  <td>{v.startTime || "Not set"}</td>
                  <td>
                    <select
                      disabled={busy}
                      aria-label={`Report visibility for ${v.date}`}
                      value={v.enabled === null ? "inherit" : String(v.enabled)}
                      onChange={(e) =>
                        save(
                          e.target.value === "inherit"
                            ? null
                            : e.target.value === "true",
                          v.id,
                        )
                      }
                    >
                      <option value="inherit">
                        Project default ({data.enabled ? "shared" : "private"})
                      </option>
                      <option value="true">Shared with client</option>
                      <option value="false">Private</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!data.visits.length && <p>No rostered visits yet.</p>}
        </>
      ) : (
        <p>Loading sharing settings…</p>
      )}
    </section>
  );
}
